import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import { Translate } from '../../utils/Translate'
import { Typography } from '@material-ui/core';
import { linkParser } from '../../utils/linkParser'
var config = require("../../assets/config.json");

class SubscriptionComponent extends Component {

    render() {
        return (
            <div>
                <div className="m-bt-lg-60 m-tb-sm-25 p-gt-sm-5">
                    <Typography variant="h1" className="subTitle">
                        {Translate({ id: "homePage.MembersAccessTitle" })}
                    </Typography>
                    <Typography variant="h3" className="subText m-t-5 m-b-20">
                        {linkParser("homePage.MembersAccessSubTitle")}

                    </Typography>
                    {this.props.isAuthenticated ? "" :
                        <Button variant="contained" color="secondary" className="m-t-15 m-t-xs-15 btn-default"
                            onClick={() => {
                                if (config.msalSsoSupport) {
                                    this.props.AuthenticateThirdPartyUser();
                                } else {
                                    this.props.history.push({ pathname: "/signup" });
                                }
                            }}>
                            <Typography variant="button">
                                {Translate({ id: "Subscription.GetAccess" })}
                            </Typography>
                        </Button>
                    }
                </div>
            </div>
        )
    }
};

export default SubscriptionComponent;
